import { FC, useEffect, useState } from "react";
import "./EmailConfirmation.styles.sass";
import { EmailConfirmationProps } from "./EmailConfirmation.types";

export const EmailConfirmation: FC<EmailConfirmationProps> = ({ email }) => {
	const [timer, setTimer] = useState<number>(60);

	useEffect(() => {
		const timerId = setTimeout(() => {
			if (timer !== 0) setTimer((prev) => prev - 1);
		}, 1000);
		return () => {
			clearTimeout(timerId);
		};
	}, [timer]);

	const sendRepeatLetter = async () => {
		try {
			await fetch(`http://91.206.14.134:9090/auth/resend?email=${email}`, {
				method: "POST",
			});
		} catch (e) {
			alert(e);
		}
		setTimer(60);
	};

	return (
		<div className="authentication confirmation">
			<h3 className="authentication-title confirmation">Заявка отправлена!</h3>
			<span className="authentication-txt confirmation">
				На почту <span className="bold">{email}</span> отправлено письмо с&nbsp;подтверждением
			</span>
			{timer > 0 && <button className="authentication-btn disabled-btn">Отправить ещё раз ({timer})</button>}
			{timer === 0 && (
				<button onClick={sendRepeatLetter} className="authentication-btn standard-btn">
					Отправить ещё раз
				</button>
			)}
		</div>
	);
};
